module.exports = __webpack_public_path__ + "static/hudson-c6a6bd48fe5c95d1bba8c38ac789aca9.jpg";